<template>
  
    <el-container>
    
      <el-main>
        <h1>Extracting annotations from pdf files</h1> 
        <div>Click <i>Import pdf highlight annotations</i> in more options</div>
        <br>
        <div>
           <img src="../assets/markmind/extract.gif" alt="" width="800">
        </div>
        
        </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'ExtractPage',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
